import { Component, inject, OnInit } from '@angular/core';
import { HorizonalBarComponent } from './horizonal-bar/horizonal-bar.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DictionaryService } from '../../../services/dictionary.service';
import { SnackbarService } from '../../../services/snackbar.service';
interface LeaveBalanceInterface {
  annualLeaves: number;
  availableAnnual: number;
  availableCasual: number;
  casualLeaves: number;
  shiftedAnnual: number;
  shiftedCasual: number;
  totalAllowedAnnual: number;
  totalAllowedCasual: number;
}
@Component({
  selector: 'app-leave-balance',
  imports: [HorizonalBarComponent],
  templateUrl: './leave-balance.component.html',
  styleUrl: './leave-balance.component.scss',
})
export class LeaveBalanceComponent implements OnInit {
  protected dictionaryService = inject(DictionaryService);
  private http = inject(HttpClient);
  private alertService = inject(SnackbarService);

  protected leaveBalance: LeaveBalanceInterface = {
    annualLeaves: 0,
    availableAnnual: 0,
    availableCasual: 0,
    casualLeaves: 0,
    shiftedAnnual: 0,
    shiftedCasual: 0,
    totalAllowedAnnual: 1,
    totalAllowedCasual: 1,
  };

  ngOnInit(): void {
    const baseUrl: string = environment.apiBaseUrl;

    this.http
      .get<{
        success: boolean;
        data: {
          leaveBalance: LeaveBalanceInterface;
        };
      }>(`${baseUrl}/activities/me/leave-balance`)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.leaveBalance = res.data.leaveBalance;
            console.log(this.leaveBalance);
          } else {
            throw new Error('Failed to fetch leave balance');
          }
        },
        error: (err) => {
          this.alertService.showError('Error fetching leave balance');
          console.error('Error fetching leave balance:', err);
        },
      });
  }
}
